import React, { useEffect, useState } from "react";
import businessLoan from "../assets/ban14.png";
import educationLoan from "../assets/ban16.png";
import emergencyLoan from "../assets/ban15.png";
import overdraftLoan from "../assets/ban13.png";

const banners = [
  {
    image: businessLoan,
    title: "India's Trusted Choice for <br /> Instant Gold & Personal Loans",
    description:
      "Unlock funds in minutes with flexible repayment options, minimal paperwork, and 100% secure storage.",
    button: "Apply Now",
    textColor: "#002147",
    btnColor: "#1E50A2",
  },
  {
    image: educationLoan,
    title: "Drive Your Dream with Easy Vehicle Loans",
    description:
      "Fast approvals, low interest, and flexible repayment options for two & four-wheelers.",
    button: "Apply Now",
    textColor: "#fff",
    btnColor: "#fff",
    btnTextColor: "#1E50A2",
  },
  {
    image: emergencyLoan,
    title: "Your Dream Home, Now  <br />Within Reach",
    description:
      "Affordable housing loans with easy EMIs, attractive interest rates, and long tenures.",
    button: "Apply Now",
    textColor: "#2353A6",
    btnColor: "#1E50A2",
  },
  {
    image: overdraftLoan,
    title: "Fuel Your Business <br /> Growth  with Shubh Paisa",
    description:
      "Flexible business loans designed for SMEs, startups, and entrepreneurs to expand faster.",
    button: "Apply Now",
    textColor: "#2353A6",
    btnColor: "#1E50A2",
  },
];

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  return (
    <div
      style={{
        ...styles.carouselContainer,
        height: isMobile ? "70vh" : isTablet ? "80vh" : "83vh",
      }}
    >
      {banners.map((banner, index) => (
        <div
          key={index}
          style={{
            ...styles.slide,
            backgroundImage: `url(${banner.image})`,
            opacity: index === current ? 1 : 0,
            zIndex: index === current ? 2 : 1,
          }}
        >
          <div style={styles.overlay}></div>

          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-1"></div> 

              <div
                className="col-10"
                style={{
                  ...styles.textContainer,
                  width: isMobile ? "90%" : isTablet ? "70%" : "55%",
                  textAlign: isMobile ? "center" : "left",
                  alignItems: isMobile ? "center" : "flex-start",
                  color: banner.textColor,
                  opacity: index === current ? 1 : 0,
                  transform:
                    index === current ? "translateY(0)" : "translateY(20px)",
                }}
              >
              <h1
  style={{
    ...styles.title,
    fontSize: isMobile ? "22px" : isTablet ? "34px" : "44px",
    textAlign: isMobile ? "center" : "left",
  }}
  dangerouslySetInnerHTML={{ __html: banner.title }}
></h1>

                <p
                  style={{
                    ...styles.description,
                    fontSize: isMobile ? "14px" : isTablet ? "16px" : "18px",
                    textAlign: isMobile ? "center" : "left",
                  }}
                >
                  {banner.description}
                </p>
                <button
                  style={{
                    ...styles.button,
                    padding: isMobile ? "10px 20px" : "12px 28px",
                    fontSize: isMobile ? "14px" : "16px",
                    backgroundColor: banner.btnColor,
                    color: banner.btnTextColor || "#fff",
                  }}
                >
                  {banner.button}
                </button>
              </div>

              <div className="col-1"></div> {/* Right spacing */}
            </div>
          </div>
        </div>
      ))}

      {/* Indicators */}
      <div style={styles.indicatorContainer}>
        {banners.map((_, index) => (
          <div
            key={index}
            style={{
              ...styles.indicator,
              backgroundColor:
                index === current ? "#1e50a2" : "rgba(255, 255, 255, 0.6)",
            }}
            onClick={() => setCurrent(index)}
          ></div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  carouselContainer: {
    position: "relative",
    width: "100%",
    overflow: "hidden",
  },
  slide: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    transition: "opacity 1s ease-in-out",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 1,
  },
  textContainer: {
    position: "relative",
    zIndex: 2,
    transition: "all 1s ease-in-out",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  title: {
    fontWeight: "700",
    marginBottom: "15px",
    lineHeight: "1.2",
  },
  description: {
    marginBottom: "20px",
    maxWidth: "500px",
  },
  button: {
    border: "none",
    fontWeight: "500",
    borderRadius: "5px",
    cursor: "pointer",
  },
  indicatorContainer: {
    position: "absolute",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: "10px",
    zIndex: 3,
  },
  indicator: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
};
